module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/vertical-group-buttons/vertical-group-buttons.component.scss
// module id = ./src/app/features/buttons/vertical-group-buttons/vertical-group-buttons.component.scss
// module chunks = main